import React from 'react'
import PropTypes from 'prop-types'
import { Form, Icon, Input, Button, Checkbox, Typography, message, Tooltip, Select } from 'antd'
import { Mutations, Queries } from '../../../graphql'
import logo from '../../../assets/images/vtrc-logo.png'
import iconsFormLabel from '../../../assets/images/icons/icon-formlabel.png'
import { Link } from 'react-router-dom'
import { withApollo } from 'react-apollo'

const { Text, Title } = Typography
const { Option } = Select;

const formItemLayout = {
	labelCol: {
	  xs: { span: 24 },
	  sm: { span: 24 },
	},
	wrapperCol: {
	  xs: { span: 24 },
	  sm: { span: 24 },
	},
  };

class BeforeLogin extends React.PureComponent {

	state = {
		captcha: '',
		checkCaptchaForm: '',
		ItemsOrganization: [],
      disabledOnSubmit: false
	}

	handleSubmit = e => {
		const { form, afterSubmit } = this.props
		const { captcha } = this.state

      this.setState({
         disabledOnSubmit: true
      })
		e.preventDefault()
		form.validateFields((err, values) => {
			if (!err && afterSubmit) {
				if(this.props.showCaptcha){
					this.setState({
						checkCaptchaForm: values.captchaUid
					})
					values.captchaUid = captcha.captchaUid
				}
				
				afterSubmit(values)

            setTimeout(() => {
               this.setState({
                  disabledOnSubmit: false
               })
            }, 2000);
			}else{
            setTimeout(() => {
               this.setState({
                  disabledOnSubmit: false
               })
            }, 2000);
         }
		})
	}

	domainLists = async () =>{
		const { client } = this.props

		try{
			const { data, errors } = await client.query({
				query: Queries.domainLists
			})
			// console.log('domainLists',data.domainLists)
			await this.setState({
				ItemsOrganization:data.domainLists
			})
		} catch (error) {
			// console.log('domainListserror',error)
			// message.error(error)
			// const errorMessage = error.graphQLErrors[0].message
		}
	}

	generateCaptcha = async() =>{
		const { client } = this.props

		try{
			const { data, errors } = await client.query({
				query: Queries.generateCaptcha
			})
			await this.setState({
				captcha: data.generateCaptcha,
				checkCaptchaForm: data.generateCaptcha.captchaUid
			})
		} catch (error) {
			// message.error(error)
			// const errorMessage = error.graphQLErrors[0].message
		}
	}

	async componentDidMount(){
		const { checkCaptcha } = this.props
		await this.generateCaptcha()
		// await this.domainLists()
		if(checkCaptcha){
			await this.setState({
				checkCaptchaForm: checkCaptcha
			})
			// await this.generateCaptcha()
		}
	}

	async componentDidUpdate(prevProps, prevState, snapshot){
		if(this.props.showCaptcha){
			if(
				prevProps.checkCaptcha === this.state.checkCaptchaForm 
			){
				await this.generateCaptcha()
				this.props.form.resetFields('captchaText')
				if(
					prevProps.checkCaptcha && 
					this.state.checkCaptchaForm
				){
					this.captchaText.focus()
				}
				// this.props.form.resetFields('captchaText')
			}
		}
	}


	render() {
		const { form, autoFocus, showCaptcha  } = this.props
		const { captcha, ItemsOrganization } = this.state
		const { getFieldDecorator } = form

		return (
			<>
				<Form onSubmit={this.handleSubmit}>
					<div style={{ display: 'flex', justifyContent: 'center', marginTop: 10, marginBottom: 20 }}>
						<img src={logo} alt="logo" className="logo-formlogin" />
					</div>
					<div style={{ textAlign: 'center', marginTop: 10, marginBottom: 10 }}>
						<Title level={3} style={{ marginBottom: '0' }}>เข้าสู่ระบบ</Title>
						<b type="secondary">เข้าสู่ระบบยืนยันตัวตนเพื่อใช้งาน</b>
					</div>
					<Form.Item 
                  label={<>
                           <p className="mb-0" style={{ lineHeight: 1.5 }}>
                              ชื่อผู้ใช้งาน<br></br>
                              <span style={{ color:"#696969" }}>(สำหรับเจ้าหน้าที่ รพ.จุฬาลงกรณ์ใช้ รหัสบุคลากร)</span>
                           </p>
                           {/* <Link
                           >
                              <img src={iconsFormLabel} style={{ maxWidth: '100%', height: '25px' }} className="mx-1"/>
                           </Link> */}
                        </>}
                  className="custom-input-login"
                  labelAlign="left" 
                  name="username" 
                  style={{ marginBottom: '0' }}
               >
						{getFieldDecorator('username', {
							initialValue: this.props.checkVerifyPassword ? this.props.username : "",
							rules: [{ required: true, message: '“กรุณาระบุชื่อผู้ใช้งาน”' }]
						})(
							<Input
								style={{ borderRadius: '100px' }}
								autoFocus={autoFocus}
								placeholder=""
                        className="mt-3"
							/>
						)}
					</Form.Item>

					{/* <Form.Item label={<b>สำนัก</b>} labelAlign="left" name="organization" style={{ marginBottom: '0' }}>
						{getFieldDecorator('organization', {
							rules: [{ required: true, message: '“กรุณาเลือกสำนัก”' }]
						})(
							<Select
								style={{ width: '100%' }}
								placeholder="เลือกสำนัก"
								filterOption={(input, option) =>
									option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
								}
							>
								{
									ItemsOrganization.map( item => (
											<Select.Option key={item.textTh} value={ item.id }>
												{ item.textTh }
											</Select.Option>
											// <Select.Option key={item.id} value={ item.value }>
											// 	{ item.textTh }
											// </Select.Option>
										)
									)
								}
							</Select>,
						)}
					</Form.Item> */}

					{
						showCaptcha &&
						<>
							<div className="mt-3">
								<ul className="mb-0 p-2">
									<li style={{ display:"inline-block", verticalAlign: "middle" }}>
										<div dangerouslySetInnerHTML={{ __html: captcha.captchaSvg}}/>
									</li>
									<li style={{ display:"inline-block", verticalAlign: "middle" }} class="ml-3 pt-2 mt-1">
										<Tooltip title="Change Captcha" >
											<Icon type="reload"  onClick={this.generateCaptcha}/>
										</Tooltip>
									</li>
								</ul>
							</div>

							<Form.Item label={<b>กรุณาใส่ตัวอักษรที่ปรากฏ (ระบุตัวเลข และตัวอักษรเท่านั้น) </b>} labelAlign="left" name="captchaText" style={{ marginBottom: '0' }}>
							{getFieldDecorator('captchaText', {
								rules: [{ required: true, message: '“กรุณาระบุรหัสภาพที่ปรากฏ”' }]
							})(
								<Input
									style={{ borderRadius: '100px' }}
									placeholder=""
									maxLength={4}
									ref={(input) => { this.captchaText = input; }} 
								/>
							)}
							</Form.Item>
						</>
						
					}
					
					<Form.Item style={{ textAlign: 'center', marginBottom: '15' }}>
						<Button 
                     className='mt-4' 
                     type="primary btn-color-default btn-custom color-white" 
                     htmlType="submit"
                     disabled={this.state.disabledOnSubmit}
                  >
							ตรวจสอบข้อมูล
						</Button>
					</Form.Item>
				
				</Form>
			</>
		)
	}
}

BeforeLogin.defaultProps = {
	autoFocus: false
}

BeforeLogin.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedBeforeLogin = Form.create()(BeforeLogin)
export default withApollo(WrappedBeforeLogin)
